import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function Error() {
  return (
    <div className={cx('Error')}>
      <h5 className={cx('title')}>잠시후 다시 이용하여 주십시요</h5>
      <p className={cx('txt')}>
        일시적인 오류로 조회하신 여정의 항공편 정보를
        <br />
        불러올 수 없습니다
      </p>
      <button
        className={cx('confirm')}
        type="button"
        onClick={() => window.location.reload()}
      >
        새로고침
      </button>
    </div>
  );
}
